// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2x4Ct","dragIcon":"Choice_dragIcon__2JhMO","left":"Choice_left__1mRMu","input":"Choice_input__qMy7T"};